import { render, staticRenderFns } from "./CarbonEmissionImport.vue?vue&type=template&id=2fb6754a&"
import script from "./CarbonEmissionImport.vue?vue&type=script&lang=js&"
export * from "./CarbonEmissionImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports